import React from 'react';
import Avatar from '@mui/material/Avatar';
import { useGetUserByIdQuery } from '@/features/user/userApi';
import { getNameInitials } from '@/utils/constants';

const WIDTH = '1.25em';
const FONT_SIZE = '0.75em';

/**
 * A user's photo, or their initials when they have none. Pass the user's Firestore doc id;
 * the avatar reads the user itself (getUserById, cached per id).
 */
export const UserAvatar = ({ userId, width = WIDTH, height = WIDTH, fontSize = FONT_SIZE, sx, ...props }) => {
	const { data: user } = useGetUserByIdQuery(userId, { skip: !userId });
	const fullName = user?.firstName ? `${user.firstName} ${user.lastName}` : (user?.name ?? user?.email);

	return (
		<Avatar
			{...(user?.imageUrl && { src: user.imageUrl })}
			sx={{ width, height, ...sx }}
			{...props}
		>
			{!user?.imageUrl && (
				<span
					style={{
						fontSize,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
					}}
				>
					{getNameInitials(fullName ?? 'N A')}
				</span>
			)}
		</Avatar>
	);
};

UserAvatar.displayName = 'UserAvatar';
